import React, { useState } from 'react'
import { Button, Form, Input, Row, Col, Select, InputNumber } from 'antd';

import AvatarUploader from 'components/AvatarUploader'
const { Option } = Select
const PatientInformation = ({ mainNext, form }) => {

    let initialState = {
        loading: false,
        imageUrl: '',
    }
    const [photoList, setPhotoState] = useState(initialState)
    const onFinish = (values) => {
        values.profileImage = photoList.imageUrl
        mainNext(values, "patientInfo")
        console.log('Success:', values);
    };

    return (
        <div>
            <Form

                name="basic"
                layout="vertical"
                onFinish={onFinish}
                form={form}

            >
                <Row className="gx-d-flex gx-flex-row ">
                    <Col xl={14} lg={14} md={12} sm={24} xs={24} className="gx-px-0">
                        <Row className="gx-d-flex  gx-flex-row">
                            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Form.Item
                                    name="firstName"
                                    label="First Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your first name!",
                                        },
                                    ]}

                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Form.Item
                                    name="lastName"
                                    label="Last Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your last name!",
                                        },
                                    ]}

                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Form.Item
                                    name="gender"
                                    label="Gender"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your gender!",
                                        },
                                    ]}

                                >
                                    <Select style={{ width: '100%' }} placeholder="Select" >
                                        <Option value="male">Male</Option>
                                        <Option value="female">Female</Option>
                                        <Option value="other">Other</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>

                    <Col xl={10} lg={10} md={12} sm={24} xs={24} className="gx-d-flex gx-justify-content-center gx-align-items-center">
                        <Row>
                            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Form.Item
                                    name="photo"
                                >
                                    <AvatarUploader setPhotoState={setPhotoState} photoList={photoList} />
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>

                </Row>
                <Row className="gx-d-flex  gx-flex-row">
                    <Col xl={14} lg={12} md={12} sm={24} xs={24}>

                        <Form.Item
                            name="age"
                            label="Age"
                            rules={[{ required: true, message: 'Please enter your age' }]}
                        >
                            <InputNumber />
                        </Form.Item>



                    </Col>

                    <Col xl={5} lg={6} md={6} sm={24} xs={24} className="gx-pr-0">
                        <Form.Item
                            name="bpSystolic"
                            label="Blood Pressure"
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter systolic blood pressure!",
                                },
                            ]}

                        >
                            <InputNumber placeholder="systolic" />
                        </Form.Item>
                    </Col>
                    <Col xl={5} lg={6} md={6} sm={24} xs={24}>
                        <Form.Item
                            name="bpDiastolic"
                            label=" "
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter diastolic blood pressure!",
                                },
                            ]}

                        >
                            <InputNumber placeholder="diastolic" />
                        </Form.Item>
                    </Col>
                </Row>





                <Row className="gx-d-flex  gx-flex-row">
                    <Col xl={14} lg={14} md={12} sm={24} xs={24}>
                        <Form.Item
                            name="bloodSugar"
                            label="Blood Sugar"
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter blood sugar!",
                                },
                            ]}

                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>
                    <Col xl={5} lg={6} md={6} sm={24} xs={24}>
                        <Form.Item
                            name="weight"
                            label="Weight"
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter the weight!",
                                },
                            ]}

                        >

                            <InputNumber placeholder="pounds" />
                        </Form.Item>
                    </Col>

                    <Col xl={5} lg={6} md={6} sm={24} xs={24}>
                        <Form.Item
                            name="height"
                            label="Height"
                            rules={[
                                {
                                    required: false,
                                    message: "Please enter the height!",
                                },
                            ]}

                        >

                            <InputNumber placeholder="inches" />
                        </Form.Item>
                    </Col>
                    
                </Row>


                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>

                    <div className="footer">
                    <div className="steps-action gx-d-flex gx-justify-content-between">

                        
                        <div className="gx-flex-1 gx-text-right">
                        <Button className="gx-pt-0 gx-mb-0" type="primary" htmlType="submit">
                            Next
                        </Button>
                        </div>
                        
                    </div>
                </div>
                    </Col>
                </Row>
                


            </Form>



        </div>
    )
}

export default PatientInformation
